const RECAPTHCA_LOCALHOST = '6LfpUvgpAAAAAH4mqrcWNgVcavvJCLDjN6Tr2Arv'
                        
export const RECAPTCHA_SITE_KEY = RECAPTHCA_LOCALHOST


//-- localhost --
// export const API_URL = URL_LOCALHOST_V1;
// export const AUTH_URL = URL_AUTH_LOCALHOST;
// export const URL_BASE = URL_LOCALHOST;

//-- android emulator --
// export const API_URL = "http://10.0.2.2:8080";
// export const AUTH_URL = "http://10.0.2.2:8080/v1";
// export const URL_BASE = "http://10.0.2.2:8080/api/auth/";
  
//--- produkcja ---
export const API_URL = "https://zapiszto-service.onrender.com/v1";
export const AUTH_URL = "https://zapiszto-service.onrender.com/api/auth/";
export const URL_BASE = "https://zapiszto-service.onrender.com";